import Link from "next/link";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
  href: string;
  current?: boolean;
}

const MenuBoxLink = ({ children, href = "", current }: Props) => {
  return current ? (
    <>
      <div className="flex flex-row items-center p-2 text-sm">
        <div className="self-stretch border border-black"></div>
        <div className="pl-2 space-y-1 font-bold">{children}</div>
      </div>
    </>
  ) : (
    <>
      <Link
        href={href}
        className="flex flex-row items-center p-2 text-sm hover:bg-neutral-300 focus:bg-neutral-300">

        <div className="self-stretch border border-transparent"></div>
        <div className="pl-2 space-y-1">{children}</div>

      </Link>
    </>
  );
};

export default MenuBoxLink;
